import Swal from "sweetalert2";

export const toastConfig = () => {
  return Swal.mixin({
    customClass: {
      container: "sweet-toast",
      htmlContainer: "sweet-toast-html",
    },
    toast: true,
    icon: "success",
    position: "top-end",
    showConfirmButton: false,
    timer: 6000,
    confirmButtonText: "close",
    confirmButtonColor: "white",
    timerProgressBar: true,
    showCloseButton: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
};

export const toastConfirm = (text, subText, html = "") => {
  const language = localStorage.getItem("i18nextLng");
  return Swal.mixin({
    title: text ? text : "Are you sure?",
    text: subText ? subText : "You wanna proceed?",
    html: html,
    customClass: {
      container: "sweet-toast",
    },
    showCancelButton: true,
    cancelButtonText: language === "gr" ? "Stornieren" : "Cancel",
    confirmButtonText: language === "gr" ? "Ja" : "Yes",
    denyButtonText: `No`,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
};

export const fireToast = (icon, title) => {
  toastConfig().fire({
    icon,
    title,
  });
};

export const fireSuccessToast = (title) => {
  fireToast("success", title);
};
